export default __webpack_public_path__ + "sort-reverse-alphabetical-order.png";